import { Link, LinkProps, NavLink, NavLinkProps } from 'react-router-dom';
import { useLocalePath } from '@/hooks/useLocalePath';
import { forwardRef } from 'react';

/**
 * A locale-aware Link that automatically prepends the current locale prefix.
 */
export const LocaleLink = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ to, ...props }, ref) => {
    const localePath = useLocalePath();
    const resolvedTo = typeof to === 'string' ? localePath(to) : to;
    return <Link ref={ref} to={resolvedTo} {...props} />;
  }
);
LocaleLink.displayName = 'LocaleLink';

/**
 * A locale-aware NavLink that automatically prepends the current locale prefix.
 */
export const LocaleNavLink = forwardRef<HTMLAnchorElement, NavLinkProps>(
  ({ to, ...props }, ref) => {
    const localePath = useLocalePath();
    const resolvedTo = typeof to === 'string' ? localePath(to) : to;
    return <NavLink ref={ref} to={resolvedTo} {...props} />;
  }
);
LocaleNavLink.displayName = 'LocaleNavLink';

export default LocaleLink;
